<template>
  <v-tooltip v-if="notifiedUsers.length > 0" bottom>
    <template v-slot:activator="{ on, attrs }">
      <v-chip :class="chipClass || 'mr-2'" x-small :color="color" :text-color="textColor" v-bind="attrs" v-on="on">
        <v-icon x-small left>{{ icon }}</v-icon>
        {{ notifiedUsers.length }}
      </v-chip>
    </template>
    <div class="white--text">
      <div class="font-weight-bold mb-1">Powiadomieni użytkownicy:</div>
      <div v-for="(user, index) in notifiedUsers" :key="index" class="d-flex align-center my-1">
        <span class="mr-2">{{ user.full_name }}</span>
        <v-icon v-for="channel in (user.channels || [])" :key="channel" medium class="mx-1 white--text">
          {{ getChannelIcon(channel) }}
        </v-icon>
      </div>
    </div>
  </v-tooltip>
</template>

<script>
// Allowed notification channels - should match backend configuration
const CHANNEL_ICONS = {
  android: 'mdi-android',
  ios: 'mdi-apple',
  sms: 'mdi-message-text',
  phone: 'mdi-phone'
};

export default {
  name: "NotifiedUsersChip",

  props: {
    notifiedUsers: {
      type: Array,
      default: () => [],
      required: true
    },
    color: {
      type: String,
      default: "blue"
    },
    textColor: {
      type: String,
      default: "white"
    },
    icon: {
      type: String,
      default: "mdi-bell"
    },
    chipClass: {
      type: String,
      default: ""
    }
  },

  methods: {
    getChannelIcon(channel) {
      return CHANNEL_ICONS[channel] || 'mdi-bell'
    }
  }
}
</script>

<style scoped>
</style>
